<template>
	<div>
		<div class="row mt-4">

			<div class="col-12 no-gutters pt-2">
				<div class="col-md-12 col-12 form-field">
					<div class="display-tooltip">
						<span class="title required-field my-2 d-block">
							<span>10. </span>
              <header-with-tooltip :tooltip-text="approximateCostTooltip"><span class="mr-1">Approximate cost</span></header-with-tooltip>
						</span>
					</div>

					<div class="mb-4">
						<span class="currencyText">
							<input
								type="number"
								id="approximateCost"
								class="form-control w-100 mt-1"
								placeholder="Approximate Cost"
								v-model="supplierOnboardRequestData.approximateSpend"
								name="supplierOnboardRequestData.approximateSpend"
								v-validate="'required|numeric'"
								min="0"
								autocomplete="off"
								data-vv-validate-on="input"
								@focus="testForValidInput"
                @blur="checkApproximateSpendLessThan5k"
							/>
						</span>
						<span
							class="text-danger input-error-text"
							v-if="errors.has('supplierOnboardRequestData.approximateSpend')"
							>Approximate cost field is required.</span
						>
					</div>
				</div>

        <div class="border-container mb-1" v-show="isApproximateSpendLessThan5k">
            <div class="display-tooltip mb-3">
              <span class="title required-field mt-2">
              <span>10a. </span>
              <header-with-tooltip
                  :tooltip-text="buyingWithCorporateCard"
                  :isHTML="true"
                  :show-icon="true">
              <span class="mr-1">Are you planning on paying for this with a corporate card?</span>
              </header-with-tooltip>
              </span>
            </div>
          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
            <label class="row no-gutters ml-3">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.corporateCardPayment"
                  v-model="supplierOnboardRequestData.corporateCardPayment"
                  :value="radio.text.toLowerCase()"
                  v-validate="isApproximateSpendLessThan5k ? 'required' : ''"
              > {{radio.displayText}}</label>
          </div>
          <div
              class="text-danger input-error-text"
              v-if="errors.has('supplierOnboardRequestData.corporateCardPayment')"
          >This field is required</div>
        </div>

				<div class="mb-2">
					<div class="title my-3" :class="[!isSupplierNameEntered() ? 'disabled-title' : 'required-field']">
              <span>11. </span>
						<span>Was this supplier suggested or recommended by a government official, or will this supplier engagement involve any of the following: (a) lobbying or of consulting on government affairs; (b) interacting with government officials on Autodesk’s behalf; or (c) services involving a government official?</span>
            <span v-if="!isSupplierNameEntered()" class="notification-text font-italic"><br>{{warningMessageForDisabledQuestions}}</span>
          </div>
          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
            <label class="row no-gutters ml-3" :class="[!isSupplierNameEntered() ? 'disabled-title' : '']">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.recommendedByGovernment"
                  v-model="supplierOnboardRequestData.recommendedByGovernment"
                  :value="radio.value"
                  v-validate="'required'"
                  :disabled="!isSupplierNameEntered()"
              > {{radio.text}}</label>
          </div>
					<div
						class="text-danger input-error-text"
						v-if="
							errors.has('supplierOnboardRequestData.recommendedByGovernment')
						"
					>
						This field is required
					</div>
				</div>

				<div class="mb-2">
					<div class="title my-3" :class="[!isSupplierNameEntered() ? 'disabled-title' : 'required-field']">
						<span>12. </span>
            <header-with-tooltip
                :tooltip-text="CONSTANTS.INTERACTING_WITH_AUTODESK_CUSTOMERS"
                :isHTML="true"
                :show-icon="true">
              <span class="mr-1">Will this supplier engagement involve them interacting with Autodesk customers on our behalf?</span>
            </header-with-tooltip>
            <span v-if="!isSupplierNameEntered()" class="notification-text font-italic"><br>{{warningMessageForDisabledQuestions}}</span>
					</div>
          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
            <label class="row no-gutters ml-3" :class="[!isSupplierNameEntered() ? 'disabled-title' : '']">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.onBehalfOfAutodeskCustomer"
                  v-model="supplierOnboardRequestData.onBehalfOfAutodeskCustomer"
                  :value="radio.value"
                  v-validate="'required'"
                  :disabled="!isSupplierNameEntered()"
              > {{radio.text}}</label>
          </div>
					<div
						class="text-danger input-error-text"
						v-if="
							errors.has('supplierOnboardRequestData.onBehalfOfAutodeskCustomer')
						"
					>
						This field is required
					</div>
				</div>

				<div class="mb-2">
					<div class="title my-3" :class="[!isSupplierNameEntered() ? 'disabled-title' : 'required-field']">
							<span>13. </span>
							<span>Do you or, to your knowledge, does anyone else at Autodesk have a relationship with the supplier or an employee of the supplier that must be disclosed and vetted under our Conflicts of Interest Policy?</span>
            <span v-if="!isSupplierNameEntered()" class="notification-text font-italic"><br>{{warningMessageForDisabledQuestions}}</span>
          </div>

          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
            <label class="row no-gutters ml-3" :class="[!isSupplierNameEntered() ? 'disabled-title' : '']">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.anyRelationshipWithAutodesk"
                  v-model="supplierOnboardRequestData.anyRelationshipWithAutodesk"
                  :value="radio.value"
                  v-validate="'required'"
                  :disabled="!isSupplierNameEntered()"
              > {{radio.text}}</label>
          </div>
					<div
						class="text-danger input-error-text"
						v-if="
							errors.has('supplierOnboardRequestData.anyRelationshipWithAutodesk')
						"
					>
						This field is required
					</div>
				</div>

        <div class="mb-2">
          <div class="title required-field my-3">
            <span>14. </span>
            <span>Will the supplier’s service or product (i.e., third-party component) be integrated into or released with any Autodesk product, service, or platform? This could include a supplier that is licensing a product or providing a SaaS or PaaS service that will be integrated in an Autodesk product</span>
          </div>
          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
            <label class="row no-gutters ml-3">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.integrateWithADSKProduct"
                  v-model="supplierOnboardRequestData.integrateWithADSKProduct"
                  :value="radio.value"
                  v-validate="'required'"
              > {{radio.text}}</label>
          </div>
          <div
              class="text-danger input-error-text"
              v-if="
							errors.has('supplierOnboardRequestData.integrateWithADSKProduct')
						"
          >
            This field is required
          </div>
        </div>

        <div class="border-container mb-2" v-show="isintegrateWithADSKProduct">
          <div class="display-tooltip">
						<span class="title required-field my-2 d-block">
							<span>14a. </span>
              <header-with-tooltip :tooltip-text="professionalServicesTooltip"><span class="mr-1">Will the supplier be engaged to provide professional services for the purpose of developing Autodesk product code?</span></header-with-tooltip>
						</span>
					</div>
          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
            <label class="row no-gutters ml-3">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.developAutodeskProductCode"
                  v-model="supplierOnboardRequestData.developAutodeskProductCode"
                  :value="radio.value"
                  v-validate="isintegrateWithADSKProduct ? 'required' : ''"
              > {{radio.text}}</label>
          </div>
          <div
              class="text-danger input-error-text"
              v-if="
							errors.has('supplierOnboardRequestData.developAutodeskProductCode')
						"
          >
            This field is required
          </div>
        </div>

        <div class="mb-2">
          <div class="title my-3">
						<span class="required-field">
							<span>15. </span>
							<span
              >Will the supplier’s engagement involve the processing of
								Autodesk personal data?</span
              >
						</span>
            <span
                :data-original-title="personalDataTooltip"
                data-toggle="tooltip"
                data-container="body"
                rel="tooltip"
                data-placement="right"
                data-html="true"
                title=""
                class="solution-link"
            ><i> What is considered personal data?</i></span
            >
          </div>

          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
            <label class="row no-gutters ml-3">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.personalDataProcessed"
                  v-model="supplierOnboardRequestData.personalDataProcessed"
                  :value="radio.value"
                  v-validate="'required'"
              > {{radio.text}}</label>
          </div>
          <div
              class="text-danger input-error-text"
              v-if="
							errors.has('supplierOnboardRequestData.personalDataProcessed')
						"
          >
            This field is required
          </div>
        </div>


        <div class="border-container mb-2" v-show="isPersonalDataProcessed">
          <div class="title required-field my-3">
            <span>15a. </span>
            <span
            >What type of personal data will the supplier be processing as a part of this engagement?</span
            >
          </div>

          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_PERSONAL_DATA_OPTIONS">
            <label class="row no-gutters ml-3">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.customerDataProcessed"
                  v-model="supplierOnboardRequestData.customerDataProcessed"
                  :value="radio.text"
                  v-validate="isPersonalDataProcessed ? 'required' : ''"
              > {{radio.displayText}}</label>
          </div>
          <div
              class="text-danger input-error-text"
              v-if="errors.has('supplierOnboardRequestData.customerDataProcessed')"
          >
            This field is required
          </div>
        </div>

        <div class="mb-4">
          <div class="title my-3">
            <span>16. </span>
            <span v-if="!isICRequest" class="required-field">Is this supplier providing any technology service (including technology professional services), platform, software, hardware, or software as a service? (e.g., installed software, AWS, technology hardware, technology professional services)?</span>
            <span v-else class="required-field">Is this supplier providing technology professional services?</span>
            <br>
            <span v-if="isProcurementCategoryTechnology" class="font-italic">This is preselected as yes, because you chose Technology for Question 4.</span>
          </div>
          <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
            <label class="row no-gutters ml-3">
              <input
                  class="vertical-radio"
                  :key="index"
                  type="radio"
                  name="supplierOnboardRequestData.thirdPartyLicenseRequired"
                  v-model="supplierOnboardRequestData.thirdPartyLicenseRequired"
                  :value="radio.value"
                  v-validate="'required'"
              > {{radio.text}}</label>
          </div>
          <div
              class="text-danger input-error-text"
              v-if="
							errors.has('supplierOnboardRequestData.thirdPartyLicenseRequired')
						"
          >
            This field is required
          </div>
        </div>

        <div class="row border-outline" v-show="isAcquiringThirdPartyTech || isICRequest">
          <strong class="border-text">Security questions</strong>

          <div class="mt-1 subsection-bold">
            <div class="mb-2" v-show="isAcquiringThirdPartyTech || isICRequest">
              <div class="title my-3 required-field">
                <span>16a. </span>
                <span>Will the supplier’s service, personnel, application, or product be accessing any Autodesk network or system in any way?</span>
              </div>
              <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
                <label class="row no-gutters ml-3">
                  <input
                      class="vertical-radio"
                      :key="index"
                      type="radio"
                      name="supplierOnboardRequestData.integrateWithADSKNetwork"
                      v-model="supplierOnboardRequestData.integrateWithADSKNetwork"
                      :value="radio.value"
                      v-validate="isAcquiringThirdPartyTech || isICRequest ? 'required' : ''"
                  > {{radio.text}}</label>
              </div>
              <div
                  class="text-danger input-error-text"
                  v-if="
                errors.has('supplierOnboardRequestData.integrateWithADSKNetwork')
              "
              >
                This field is required
              </div>
            </div>

            <div class="mb-1" v-show="isAcquiringThirdPartyTech">
              <div class="title my-3" :class="[isICRequest ? 'disabled-subsection' : 'required-field']">
                <span>16b. </span>
                <span>Will the supplier be installing any code, cookie, or tag on an Autodesk website?</span>
                <span v-if="isICRequest" class="disabled-subsection font-italic"><br>{{CONSTANTS.warningMessageForICDisabledQuestions}}</span>
              </div>
              <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
                <label class="row no-gutters ml-3" :class="[isICRequest ? 'disabled-subsection' : '']">
                  <input
                      class="vertical-radio"
                      :key="index"
                      type="radio"
                      name="supplierOnboardRequestData.cookieInstalledOnADSKNetwork"
                      v-model="supplierOnboardRequestData.cookieInstalledOnADSKNetwork"
                      :value="radio.value"
                      v-validate="isAcquiringThirdPartyTech && !isICRequest ? 'required' : ''"
                      :disabled="isICRequest"
                  > {{radio.text}}</label>
              </div>
              <div
                  class="text-danger input-error-text"
                  v-if="errors.has('supplierOnboardRequestData.cookieInstalledOnADSKNetwork')"
              >This field is required</div>
            </div>

            

            <div class="mb-1" v-show="isAcquiringThirdPartyTech">
              <div class="title my-3 required-field">
                <span>16c. </span>
                <span>Will the supplier have access to or process any customer intellectual property?</span>
              </div>
              <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
                <label class="row no-gutters ml-3">
                  <input
                      class="vertical-radio"
                      :key="index"
                      type="radio"
                      name="supplierOnboardRequestData.customerIntellectualProperty"
                      v-model="supplierOnboardRequestData.customerIntellectualProperty"
                      :value="radio.value"
                      v-validate="isAcquiringThirdPartyTech ? 'required' : ''"
                  > {{radio.text}}</label>
              </div>
              <div
                  class="text-danger input-error-text"
                  v-if="errors.has('supplierOnboardRequestData.customerIntellectualProperty')"
              >This field is required</div>
            </div>


            <div class="mb-1" v-show="isAcquiringThirdPartyTech">
              <div class="title my-3" :class="[isICRequest ? 'disabled-subsection' : 'required-field']">
                <span>16d. </span>
                <span>If purchasing software, are the licenses installed on an Autodesk device or within the Autodesk network?</span>
                <span v-if="isICRequest" class="disabled-subsection font-italic"><br>{{CONSTANTS.warningMessageForICDisabledQuestions}}</span>
              </div>
              <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_LISCENCE_INSTALLED_RADIO_OPTIONS">
                <label class="row no-gutters ml-3" :class="[isICRequest ? 'disabled-subsection' : '']">
                  <input
                      class="vertical-radio"
                      :key="index"
                      type="radio"
                      name="supplierOnboardRequestData.softwareInstalledOnADSKMachine"
                      v-model="supplierOnboardRequestData.softwareInstalledOnADSKMachine"
                      :value="radio.text"
                      v-validate="isAcquiringThirdPartyTech && !isICRequest ? 'required' : ''"
                      :disabled="isICRequest"
                  > {{radio.displayText}}</label>
              </div>
              <div
                  class="text-danger input-error-text"
                  v-if="errors.has('supplierOnboardRequestData.softwareInstalledOnADSKMachine')"
              >This field is required</div>
            </div>

            <div class="mb-1" v-show="isAcquiringThirdPartyTech">
              <div class="title my-3" :class="[isICRequest ? 'disabled-subsection' : 'required-field']">
                <span>16e. </span>
                <span>Is this engagement a pilot or proof of concept?</span>
                <span v-if="isICRequest" class="disabled-subsection font-italic"><br>{{CONSTANTS.warningMessageForICDisabledQuestions}}</span>
              </div>
              <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
                <label class="row no-gutters ml-3" :class="[isICRequest ? 'disabled-subsection' : '']">
                  <input
                      class="vertical-radio"
                      :key="index"
                      type="radio"
                      name="supplierOnboardRequestData.isPilotOrProofOfConcept"
                      v-model="supplierOnboardRequestData.isPilotOrProofOfConcept"
                      :value="radio.value"
                      v-validate="isAcquiringThirdPartyTech && !isICRequest ? 'required' : ''"
                      :disabled="isICRequest"
                  > {{radio.text}}</label>
              </div>
              <div
                  class="text-danger input-error-text"
                  v-if="errors.has('supplierOnboardRequestData.isPilotOrProofOfConcept')"
              >This field is required</div>
            </div>

            <div class="mb-1" v-show="isAcquiringThirdPartyTech">
              <div class="title my-3 required-field">
                <span>16f. </span>
                <span>Will the supplier service or product involve any artificial intelligence or machine learning?</span>
              </div>
              <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
                <label class="row no-gutters ml-3">
                  <input
                      class="vertical-radio"
                      :key="index"
                      type="radio"
                      name="supplierOnboardRequestData.artificialIntelligenceOrMachineLearning"
                      v-model="supplierOnboardRequestData.artificialIntelligenceOrMachineLearning"
                      :value="radio.value"
                      v-validate="isAcquiringThirdPartyTech ? 'required' : ''"
                  > {{radio.text}}</label>
              </div>
              <div
                  class="text-danger input-error-text"
                  v-if="errors.has('supplierOnboardRequestData.artificialIntelligenceOrMachineLearning')"
              >This field is required</div>
            </div>

            <div class="mb-1" v-show="isAcquiringThirdPartyTech && isArtificialIntelligenceOrMachineLearning">
              <div class="title my-3 required-field">
                  <span>16g. </span>
                  <header-with-tooltip
                          :tooltip-text="isGenerativeAiTooltip"
                          :isHTML="true"
                          :show-icon="true">
                      <span class="mr-1">Does this engagement involve Generative AI?</span>
                  </header-with-tooltip>
              </div>
              <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_OPTIONS">
                  <label class="row no-gutters ml-3">
                      <input
                              :key="index"
                              class="vertical-radio"
                              type="radio"
                              name="supplierOnboardRequestData.generativeAI"
                              v-model="supplierOnboardRequestData.generativeAI"
                              :value="radio.text"
                              v-validate="isAcquiringThirdPartyTech && isArtificialIntelligenceOrMachineLearning ? 'required' : ''"
                      > {{radio.displayText}}</label>
              </div>
              <div class="ml-2 border-container"  v-show="isGenerativeAI">
                  <div>
                      <label class="row no-gutters required-field mt-2 mb-2 d-inline-block">
                          <input
                                  key="index"
                                  type="checkbox"
                                  v-validate="supplierOnboardRequestData.generativeAI === 'yes' ? 'required' : ''"
                                  name="supplierOnboardRequestData.genAIAttestationSubmitted"
                                  v-model="supplierOnboardRequestData.genAIAttestationSubmitted"
                                  data-vv-validate-on="input"
                          ><span class="ml-1 ">I have completed the steps required for using a Generative AI tool and this engagement has been approved by the Governance  <span class="ml-4">Committee for Generative AI team OR I do not need approval for this tool since it is <a href='https://one.autodesk.com/LEGAL/articles/0b363c041b11e5d0c987a9f5624bcbc7' target='_blank'>pre-approved.</a></span></span></label>
                      
                  </div>
                  <div
                      class="text-danger input-error-text"
                      v-if="errors.has('supplierOnboardRequestData.genAIAttestationSubmitted')"
              >This field is required</div>
                  <div class="mt-1">
                      <span class="notification-text font-italic" v-html="notificationTextGenerativeAI"></span>
                  </div>
              </div>
              <div
                      class="text-danger input-error-text"
                      v-if="errors.has('supplierOnboardRequestData.generativeAI')"
              >This field is required</div>
          </div>


          </div>
        </div>

				<div class="float-md-right mt-4 pr-0">
					<button
						class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3"
						@click="navigateToHome"
					>
						Cancel
					</button>
					<button
						class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3"
						@click="saveSupplierOnboardRequest(true)"
					>
						Save Draft
					</button>
					<button
						class="btn-container btn flat-btn primary-blue-btn ml-2 my-3"
						@click="submitDataOrLaunchShortForm()"
					>
						Next
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import ShortForm from "@/components/OneIntakeForm/ShortForm";
import supplierRequestMixin from "@/mixins/supplierRequestMixin";
import HeaderWithTooltip from "../HeaderWithTooltip";
import CONSTANTS from "../../store/constants";

export default {
	name: "AdditionalDetails",
  components: {HeaderWithTooltip},
  mixins: [supplierRequestMixin],
	data() {
		return {
		  isApproximateSpendLessThan5k : false,
      isSoftwareFreeOrPaid : false,
      warningMessageForDisabledQuestions: "This question does not require an answer at this time, as no supplier was named. It will be enabled when you add a supplier name.",
      approximateCostTooltip: CONSTANTS.APPROXIMATE_SPEND_TOOLTIP,
      professionalServicesTooltip: CONSTANTS.PROFESSIONAL_SERVICES_TOOLTIP,
      notificationTextGenerativeAI: "<span>If you have not received approval from the team, please submit the form <a href='"+CONSTANTS.GENERATIVE_AI.GENERATIVE_AI_CREATE_RECORD_ARTICLE+"' target='_blank'>here</a> and get approval from that team before submitting this enhancement request form. If you have any questions they can be submitted at <a href='"+CONSTANTS.GENERATIVE_AI.GENERATIVE_AI_SLACK_URL+"'' target='_blank'>#adsk-generative-ai-tools</a></span>"
    };
	},
	created() {
    this.initializeAdditionalDetails()
	},
  watch: {
    isApproximateSpendLessThan5k(val){
      if (!val){
        return this.supplierOnboardRequestData.corporateCardPayment = null
      }
    },
    isPersonalDataProcessed(val){
      if (!val){
        return this.supplierOnboardRequestData.customerDataProcessed = null
      }
    },
    isintegrateWithADSKProduct(val){
      if (!val){
        return this.supplierOnboardRequestData.developAutodeskProductCode = null
      }
    },
    isAcquiringThirdPartyTech(val){
      if (!val){
        //This method clears out values from 15a to 15g , when Q15 is set to false.
        this.$set(this.$store.state.supplierOnboardRequestData, 'integrateWithADSKNetwork',null);
        this.$set(this.$store.state.supplierOnboardRequestData, 'cookieInstalledOnADSKNetwork',null);
        this.$set(this.$store.state.supplierOnboardRequestData, 'artificialIntelligenceOrMachineLearning',null);
        this.$set(this.$store.state.supplierOnboardRequestData, 'customerIntellectualProperty',null);
        this.$set(this.$store.state.supplierOnboardRequestData, 'softwareInstalledOnADSKMachine',null);
        this.$set(this.$store.state.supplierOnboardRequestData, 'generativeAI',null);
        this.$set(this.$store.state.supplierOnboardRequestData, 'genAIAttestationSubmitted',false);
        this.$set(this.$store.state.supplierOnboardRequestData, 'isPilotOrProofOfConcept',null);
      }
    },
    isGenerativeAI(val){
      //this method unchecks the attestation if the user selects No for 15f.
      if(!val){
        this.$set(this.$store.state.supplierOnboardRequestData, 'genAIAttestationSubmitted',false);
      }
    },
    isArtificialIntelligenceOrMachineLearning(val){
      if(!val){
        this.$set(this.$store.state.supplierOnboardRequestData, 'generativeAI',null);
        this.$set(this.$store.state.supplierOnboardRequestData, 'genAIAttestationSubmitted',false);
      }
    },
  },
	methods: {
		...mapMutations(["setCurrentTab"]),
    initializeAdditionalDetails(){
      this.checkApproximateSpendLessThan5k()
      window.scrollTo(0, 0);
      this.initializeTooltip();
    },
		submitDataOrLaunchShortForm() {
			this.$validator.validateAll().then((success) => {
				if (success) {
					if (this.isCandidateForShortForm()) {
						this.launchShortForm();
					} else {
						this.setCurrentTab("PreviewDetails");
					}
				} else {
					window.scrollTo(0, 0);
				}
			});
		},
		initializeTooltip() {
			/* eslint-disable no-undef */
			this.$nextTick(function() {
				$('[data-toggle="tooltip"]').tooltip();
			});
		},
		launchShortForm() {
			document.documentElement.style.overflow = "hidden";
			this.$modal.show(
				ShortForm,
				{},
				{
					adaptive: true,
					height: "650",
					width: "730",
				},
				{
					closed: () => {
						document.documentElement.style.overflow = "auto";
					},
				}
			);
		},
    checkApproximateSpendLessThan5k(){
      if (this.supplierOnboardRequestData.approximateSpend !== "" && this.supplierOnboardRequestData.approximateSpend <= CONSTANTS.APPROXIMATE_SPEND_VALUE && this.supplierOnboardRequestData.approximateSpend > 0){
        this.isApproximateSpendLessThan5k = true
      }else{
        this.isApproximateSpendLessThan5k = false
      }
    },
	},
  computed: {
		...mapGetters([
			"supplierOnboardRequestData",
			"approximateSpendOptions",
      "supplierServiceCategoryOptions"
		]),
		personalDataTooltip() {
			return `<span>
      To “process personal data” means to use, modify, copy, store, transfer,
      or have access to any information relating to an identified or identifiable natural person,
      including name, address, telephone number, email address, social media name, IP address, title, employer, unique ID, etc.
      This type of data can directly identify an individual (name, geo-location, email, IP address, cookies, etc.)
      or indirectly be linked back to an individual (usage data, work product, Oxygen ID, geo-location, etc.)
      </span>`;
		},
    isGenerativeAiTooltip(){
            return `<span>
      Generative AI means using AI to generate text, code, images, or other media in response to prompts. See <a href=${CONSTANTS.GENERATIVE_AI.GENERATIVE_AI_LEGAL_ARTICLE} target="_blank">here</a> for more information
      </span>`;
    },
    isPersonalDataProcessed(){
		  return (this.supplierOnboardRequestData.personalDataProcessed === true);
    },
    isintegrateWithADSKProduct(){
      return (this.supplierOnboardRequestData.integrateWithADSKProduct === true);
    },
    buyingWithCorporateCard(){
      return `<span>
      You can use your corporate card to pay if your purchase is: <br> (1) less than $5,000 USD-equivalent and <br> (2) not for laptops, desktops, servers, mobile computing devices, professional services or gift cards – <br> contact the Card Team with questions <a href=${CONSTANTS.LUMI_SLACK} target="_blank">on Lumi via Slack</a>
      </span>`;
    }
	},
};
</script>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css"></style>

<style scoped>
.display-tooltip {
	display: flex;
}

.currencyText {
	display: flex;
	position: relative;
}
.currencyText input {
	padding-left: 23px;
}
.currencyText::before {
	position: absolute;
	content: "$";
	left: 7px;
	top: 9px;
	font-size: 19px;
}

.subsection-bold{
  color: #000000;
}

.disabled-subsection{
  color: #A3A3A3;
}
</style>
